import React, { useState, useEffect, useRef } from 'react';
import { Row, Button, Col, Container, Form, Alert } from 'react-bootstrap';
import { language } from '../../language';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';

import './useragreement.css';

const html1_en = (
    <React.Fragment>
        <h4 className="text-center">INFORMED CONSENT FOR RESEARCH</h4>
        <p>
            <span style={{ fontWeight: 'bold' }}>Study Title:</span> Analytics
            of Information Influence: Extraction of Population Attributes
        </p>
        <p>
            <span style={{ fontWeight: 'bold' }}>Principal Investigator: </span>
            Morteza Dehghani, PhD
        </p>
        <p>
            <span style={{ fontWeight: 'bold' }}>Department: </span> Department
            of Psychology
        </p>
        <hr />
        <p>
            We invite you to take part in a research study. Please take as much
            time as you need to read the consent form. If you find any of the
            language difficult to understand, please ask questions. If you
            decide to participate, you will be asked to electronically sign this
            form.{' '}
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PURPOSE
        </p>
        <p>
            The purpose of this study is to find out what values are important
            to different people. We hope to learn about what people think about
            various issues and how they write about them. You are invited as a
            possible participant because you are an English-speaking Twitter
            user. About 10,000 participants will take part in the study. This
            research is being funded by the Defense Advanced Research Projects
            Agency.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PROCEDURES
        </p>
        <p>
            If you decide to take part, you will be asked to complete a series
            of questionnaires, respond to some writing prompts, and answer
            questions about your age, gender and other demographics. You will
            also be asked about the kind of media you consume and what your
            Twitter handle is. The investigators will relate publicly available
            data from your Twitter timeline to your survey responses to examine
            how your values and beliefs relates to your language use.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            RISKS AND DISCOMFORTS
        </p>
        <p>
            Possible risks and discomforts you could experience during this
            study include:
        </p>
        <ul>
            <li>
                Some of the questions may make you feel uneasy or embarrassed.
                You can choose to skip or stop answering any questions you don't
                want to.
            </li>
            <li>
                There is a small risk that people who are not connected with
                this study will learn your identity or your personal
                information.
            </li>
        </ul>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            BENEFITS
        </p>
        <p>
            There are no direct benefits to you from taking part in this study.
            However, your participation in this study may help us learn how
            moral values shape public discourse.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PRIVACY/CONFIDENTIALITY
        </p>
        <p>
            We will keep your records for this study confidential as far as
            permitted by law. However, if we are required to do so by law, we
            will disclose confidential information about you. Efforts will be
            made to limit the use and disclosure of your personal information,
            including research study and medical records, to people who are
            required to review this information. We may publish the information
            from this study in journals or present it at meetings. If we do, we
            will not use your name.
        </p>
        <p>
            The University of Southern California's Institutional Review Board
            (IRB) and Human Subject's Protections Program (HSPP) may review your
            records. Organizations that may also inspect and copy your
            information include The Department of Defense (DOD) or Federal
            representatives may also access research records for the purpose of
            protecting human subjects. Officials of the U.S. Army Research
            Protections Office and the Army Research Laboratory's Human Research
            Protection Program are permitted by law to inspect the records
            obtained in this study to insure compliance with laws and
            regulations covering experiments using human subjects.
        </p>
        <p>
            Your responses, which are also called 'data', will be stored for the
            duration of the research project, that is, 5 years from data
            collection. Members of the research teams, including researchers at
            the University of Illinois Urbana-Champaign, will have access to the
            data. If there is a data breach which could pose any risk to you,
            you will be informed of the breach.
        </p>
        <p>
            Your data collected as part of this research will be used or
            distributed for future research studies without your additional
            informed consent. Any information that identifies you (such as your
            Twitter user name) will be removed from the data before being shared
            with others or used in future research studies.
        </p>
        <p>
            To understand the privacy and confidentiality limitations associated
            with using Twitter, we strongly advise you to familiarize yourself
            with their privacy policies.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            ALTERNATIVES{' '}
        </p>
        <p>
            An alternative to participating in this study would be to not
            participate in this study.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PAYMENTS / COMPENSATION
        </p>
        <p>
            If you were recruited from Qualtrics Panels, you will be compensated
            by Qualtrics Panels based on the agreed upon rate with Qualtrics.
            You do not have to answer all of the questions in order to receive
            compensation.
        </p>
        <p>
            If you were recruited via Twitter Ads, you will be compensated by
            the investigators and will receive an Amazon gift card for $5. After
            completing the main survey, you will be redirected to a separate
            survey, not connected to the study, in which you enter your email
            address. We will send you a digital gift card no later than two
            weeks after you completed the survey. You do not have to answer all
            of the questions in order to receive compensation.
        </p>
        <p>
            Payments for research participation are considered taxable income
            and participants may be required to pay taxes on this income. If
            participants are paid $600 or more in total within a calendar year
            for participation in one or more research studies, the University
            will report this as income to the IRS and participants may receive
            an Internal Revenue Service (IRS) Form 1099. This does not include
            any payments you receive to pay you back for expenses like parking
            fees.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            VOLUNTARY PARTICIPATION
        </p>
        <p>
            It is your choice whether to participate. If you choose to
            participate, you may change your mind and leave the study at any
            time. If you decide not to participate, or choose to end your
            participation in this study, you will not be penalized or lose any
            benefits that you are otherwise entitled to.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            CONTACT INFORMATION
        </p>
        <p>
            If you have questions, concerns, complaints, or think the research
            has hurt you, write to the study investigator, Morteza Dehghani
            (mdehghan@usc.edu). This research has been reviewed by the USC
            Institutional Review Board (IRB). The IRB is a research review board
            that reviews and monitors research studies to protect the rights and
            welfare of research participants. Contact the IRB if you have
            questions about your rights as a research participant or you have
            complaints about the research. You may contact the IRB at (323)
            442-0114 or by email at irb@usc.edu.
        </p>
        <h4 className="text-center">STATEMENT OF CONSENT</h4>
    </React.Fragment>
);

const html2_en = (
    <React.Fragment>
        <hr />
        <h6>
            CONSENT TO COLLECT AND PROCESS PERSONAL DATA FROM THE EUROPEAN UNION
        </h6>
        <p>
            This privacy notice applies to all personal information that the
            University of Southern California (USC) and the researchers
            identified in the informed consent collect or process about you in
            connection with your participation in this research project.
            Personal information is information about you through which you can
            be identified (including where you can be identified by combining
            the information with other information). Some of this personal
            information may include information which is classified as{' '}
            <span style={{ fontWeight: 'bold' }}>“sensitive”</span> under local
            privacy laws (for example, information about your physical and
            mental health).
        </p>
        <p>
            Information collected about you for this research project includes
            personal information, such as demographic data and may include
            sensitive data, such as:
        </p>
        <ul>
            <li>racial or ethnic origin </li>
            <li>political opinions </li>
            <li>religious or philosophical beliefs </li>
            <li>trade union membership </li>
            <li>genetics or biometrics</li>
            <li>health </li>
            <li>sex life or sexual orientation </li>
            <li>criminal record</li>
        </ul>
        <p>
            The legal basis for collecting and processing your personal
            information is one or more of the following:
        </p>
        <ul>
            <li>
                You have consented to the collection and processing of your
                personal information; and/or
            </li>
            <li>
                USC is collecting and processing your personal information to
                necessary for the performance of a task carried out in the
                public interest;
            </li>
            <li>As necessary by law.</li>
        </ul>
        <p>
            Your data will be used and/or stored as long as needed for the
            research study and consistent with the term of the USC HIPAA
            Authorization to Use Personal Information for Research Purposes.{' '}
        </p>
        <p style={{ textDecoration: 'underline' }}>Your Rights</p>
        <ul>
            <li>
                You have the right to see the information being collected about
                you in the study. To ensure integrity of the study, you will not
                be able to review some of the data until after the study has
                been completed. For example, if you are in a blinded study,
                neither the researchers nor you will be able to know the study
                arm in which you participated until after the study is over.
            </li>
            <li>
                You have the right to request corrections to your Personal
                Information if it is inaccurate.
            </li>
            <li>
                You have the right to limit the collection and use of your
                Personal Information under certain circumstances (for example,
                if you think that the information is inaccurate).
            </li>
            <li>
                •You have the right to request the deletion of your Personal
                Information if you are no longer participating in the study.
                However, there are limits on your ability to request deletion of
                your Personal Information such as if deletion would seriously
                impair the integrity or the efficacy of the study or if your
                Personal Information is needed to comply with legal
                requirements.
            </li>
            <li>
                • You have the right to file a complaint with a data protection
                authority
                <a href="http://ec.europa.eu/justice/data-protection/article-29/structure/data-protection-authorities/index_en.htm">
                    (http://ec.europa.eu/justice/data-protection/article-29/structure/data-protection-authorities/index_en.htm).
                </a>
            </li>
        </ul>
        <p style={{ textDecoration: 'underline' }}>Withdrawal from the Study</p>
        <p>
            If you withdraw from the study, you will no longer be able to
            participate in the study. No new information or samples will be
            collected about you or from you by the study team. Your withdrawal
            has no effect on the lawfulness of the data processing that occurred
            prior to your withdrawal.
        </p>
        <p>
            After your withdrawal, your data and personal information may still
            be maintained to maintain the integrity of the study, to satisfy any
            legal or regulatory requirements including reporting and retention
            requirements, and/or for any other purposes permitted under
            applicable data protection and privacy laws. Your Personal
            Information also may be anonymized so that the information does not
            identify you personally, and such anonymized information may be used
            for further research.{' '}
        </p>
        <p style={{ textDecoration: 'underline' }}>Security</p>
        <p>
            We implement technical and organizational measures to ensure a level
            of security appropriate to the risk to the personal information we
            process. These measures are aimed at ensuring the ongoing integrity
            and confidentiality of personal information. We evaluate these
            measures on a regular basis to ensure the security of the
            processing. For more information on the appropriate safeguards in
            place, please contact us at the email address below.
        </p>
        <p>
            We will retain your personal information in accordance with our
            Record Management policy, available at{' '}
            <a href="https://policy.usc.edu/record-management/">
                https://policy.usc.edu/record-management/
            </a>
            , which sets out data retention periods required or permitted by
            applicable law.
        </p>
        <p style={{ textDecoration: 'underline' }}>
            International Data Transfer
        </p>
        <p>
            Your data will be used and shared with the researchers and sponsors
            on this research study as well as government regulators and as fully
            described in the HIPAA Authorization to Use Personal Information for
            Research Purposes. Your personal information may be shared with
            individuals outside your country, including the United States, and
            will be treated in compliance with applicable data protection laws.
            Data privacy and protection in those countries may not offer the
            same level of protection as those in your own country.
        </p>
        <p style={{ textDecoration: 'underline' }}>Contact Information</p>
        <p>
            If you have questions or concerns regarding the way in which your
            personal information has been used, please contact Morteza Dehghani
            (mdehghan@usc.edu).
        </p>
        <p style={{ textDecoration: 'underline' }}>Changes to the Notices</p>
        <p>
            You may request a copy of this privacy notice from us using the
            contact details set out above. We may modify or update this privacy
            notice from time to time. You will be able to see when we last
            updated the privacy notice because we will include a revision date.
            Changes and additions to this privacy notice are effective from the
            date on which they are posted. Where changes to this policy will
            have a fundamental impact on the nature of the processing or
            otherwise have a substantial impact on you, we will give you
            sufficient advance notice so that you have the opportunity to
            exercise your rights (for example, to object to the processing).
        </p>
    </React.Fragment>
);

const html1_fr = (
    <React.Fragment>
        <h4 className="text-center agreement">
            CONSENTEMENT ÉCLAIRÉ À UNE RECHERCHE
        </h4>
        <p>
            <span style={{ fontWeight: 'bold' }}>Titre de l’étude: </span>
            Analyse de l’influence de l’information : Détermination des
            attributs de population
        </p>
        <p>
            <span style={{ fontWeight: 'bold' }}>Chercheur principal: </span>
            Morteza Dehghani, PhD
        </p>
        <p>
            <span style={{ fontWeight: 'bold' }}>Département: </span>{' '}
            Département de psychologie
        </p>
        <hr />
        <p>
            Nous vous invitons à participer à une étude de recherche. Veuillez
            prendre le temps nécessaire pour lire le formulaire de consentement.
            Si vous rencontrez des difficultés dans la compréhension de la
            langue, merci de poser des questions. Si vous décidez de participer,
            il vous sera demandé de signer électroniquement ce formulaire.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            OBJECTIF
        </p>
        <p>
            Le but de cette étude est de déterminer les valeurs importantes pour
            différentes personnes. Nous souhaitons découvrir ce que les gens
            pensent au sujet de différentes questions et ce qu’ils en expriment
            à l’écrit. Vous êtes invité(e) en tant que participant(e)
            potentiel(le) car vous êtes un(e) utilisateur/rice francophone de
            Twitter. Environ 10 000 participants prendront part à l’étude. Cette
            recherche est financée par la Defense Advanced Research Projects
            Agency.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PROCÉDURES
        </p>
        <p>
            Si vous décidez de participer, il vous sera demandé de remplir une
            série de questionnaires, de vous exprimer sur des sujets de
            rédaction et de répondre à des questions sur votre âge, votre sexe
            et d’autres données démographiques. Il vous sera également demandé
            quel type de média vous utilisez et quel est votre compte Twitter.
            Les enquêteurs associeront les données accessibles au public de
            votre chronologie Twitter à vos réponses à l’enquête pour examiner
            le lien entre vos valeurs et croyances et votre utilisation de la
            langue.
        </p>
        <p
            style={{ fontWeight: 'bold', textDecoration: 'underline' }}
            className="agreement"
        >
            RISQUES ET DIFFICULTÉS
        </p>
        <p>
            Les risques et difficultés que vous pourriez rencontrer au cours de
            cette étude comprennent :
        </p>
        <ul>
            <li>
                Certaines questions peuvent vous procurer un sentiment de gêne
                ou d’embarras. Vous pouvez choisir d’ignorer les questions
                auxquelles vous ne souhaitez pas répondre ou de vous arrêter en
                cours de réponse.
            </li>
            <li>
                Il existe un faible risque que des personnes non associées à
                cette étude soient amenées à prendre connaissance de votre
                identité ou des informations personnelles vous concernant.
            </li>
        </ul>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            AVANTAGES
        </p>
        <p>
            La participation à cette étude ne représente aucun avantage direct
            pour vous. Cependant, votre participation à cette étude peut nous
            aider à comprendre comment les valeurs morales façonnent le discours
            public.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            VIE PRIVÉE/CONFIDENTIALITÉ
        </p>
        <p>
            Vos informations, collectées dans le cadre de cette étude, seront
            tenues confidentielles dans la mesure permise par la loi. Cependant,
            si la loi nous y oblige, nous pourrons être amenés à divulguer des
            informations confidentielles vous concernant. Nous nous efforcerons
            de restreindre l’utilisation et la divulgation de vos informations
            personnelles, médicales ou issues de l’étude de recherche, aux
            personnes dont la consultation sera nécessaire. Nous pourrons être
            amenés à publier les informations de cette étude dans des revues ou
            à les présenter lors de réunions. Si tel est le cas, nous
            n’utiliserons pas votre nom.
        </p>
        <p>
            L’Institutional Review Board (IRB) de l’Université de Californie du
            Sud (USC) et le Human Subject’s Protections Program (HSPP) pourront
            être amenés à examiner vos dossiers. Les organisations pouvant
            également consulter et copier vos informations incluent le ministère
            de la Défense (DOD). Les représentants fédéraux peuvent également
            accéder aux dossiers de recherche dans un but de protection des
            sujets humains. Les fonctionnaires de l’US Army Research Protections
            Office et du Human Research Protection Program de l’Army Research
            Laboratory sont autorisés par la loi à inspecter les informations
            obtenues dans cette étude pour s’assurer de sa conformité aux lois
            et réglementations concernant les expériences utilisant des sujets
            humains.
        </p>
        <p>
            Vos réponses, également appelées « données », seront conservées
            pendant toute la durée du projet de recherche, soit 5 ans à compter
            de leur collecte. Les membres des équipes de recherche, y compris
            des chercheurs de l’Université de l’Illinois Urbana-Champaign,
            auront accès aux données. En cas de violation de données susceptible
            de présenter un risque pour vous, vous serez informé(e) de la
            violation.
        </p>
        <p>
            Les données vous concernant collectées dans le cadre de cette
            recherche seront utilisées ou distribuées pour de futures études
            sans consentement éclairé supplémentaire. Toute information qui vous
            identifie (telle que votre nom d’utilisateur Twitter) sera supprimée
            des données avant d’être partagée ou utilisée dans de futures
            études.
        </p>
        <p>
            Pour comprendre les limitations de confidentialité associées à
            l’utilisation de Twitter, nous vous recommandons fortement de bien
            prendre connaissance de sa politique de confidentialité.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            AUTRES SCÉNARIOS
        </p>
        <p>
            Il vous est également possible de ne pas participer à cette étude.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PAIEMENTS / INDEMNISATION
        </p>
        <p>
            Si vous avez été recruté(e) par des panels Qualtrics, vous serez
            rémunéré(e) par les panels Qualtrics sur la base du tarif convenu
            avec Qualtrics. Vous n’êtes pas obligé(e) de répondre à toutes les
            questions pour recevoir une indemnisation.
        </p>
        <p>
            Si vous avez été recruté(e) via Twitter Ads, vous serez rémunéré(e)
            par les enquêteurs et recevrez une carte-cadeau Amazon de 5 $. Après
            avoir terminé l’enquête principale, vous serez redirigé(e) vers une
            enquête distincte, non liée à l’étude, dans laquelle vous devrez
            renseigner votre adresse e-mail. Nous vous enverrons une
            carte-cadeau numérique au plus tard deux semaines après votre
            réponse au sondage. Vous n’êtes pas obligé de répondre à toutes les
            questions pour recevoir une indemnisation.
        </p>
        <p>
            Les paiements pour la participation à la recherche sont considérés
            comme un revenu imposable et les participants peuvent être tenus de
            payer des impôts sur ce revenu. Pour les participants ayant reçu au
            total 600 $ ou plus au cours d’une année civile pour leur
            participation à une ou plusieurs études de recherche, l’Université
            en fera la déclaration comme un revenu à l’IRS et les participants
            pourront recevoir un formulaire 1099 de l’Internal Revenue Service
            (IRS). Cela n’inclut pas les paiements que vous recevez en
            compensation de dépenses telles que les frais de stationnement.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            PARTICIPATION VOLONTAIRE
        </p>
        <p>
            La participation relève de votre propre choix. Si vous choisissez de
            participer, vous pouvez changer d’avis et quitter l’étude à tout
            moment. Si vous décidez de ne pas participer, ou choisissez de
            mettre fin à votre participation à cette étude, vous ne serez pas
            pénalisé(e) et ne perdrez aucun avantage auquel vous avez autrement
            droit.
        </p>
        <p style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            COORDONNÉES DE CONTACT
        </p>
        <p>
            Si vous avez des questions, des préoccupations, des réclamations ou
            si vous pensez que la recherche vous a lésé(e), veuillez contacter
            par écrit l’investigateur de l’étude, Morteza Dehghani
            (mdehghan@usc.edu).
        </p>
        <p>
            Cette recherche a été examinée par l’Institutional Review Board
            (IRB) de l’USC. L’IRB est un comité de surveillance de la recherche
            qui contrôle et examine les études de recherche afin de protéger les
            droits et le bien-être des participants. Contactez l’IRB si vous
            avez des questions sur vos droits en tant que participant(e) à la
            recherche ou si vous avez des plaintes concernant la recherche. Vous
            pouvez contacter l’IRB au (323) 442-0114 ou par courriel à
            irb@usc.edu.
        </p>
        <h4 className="text-center agreement">DÉCLARATION DE CONSENTEMENT</h4>
    </React.Fragment>
);
const html2_fr = (
    <React.Fragment>
        <hr />
        <h6>
            CONSENTEMENT À LA COLLECTE ET AU TRAITEMENT DES DONNÉES PERSONNELLES
            DE L’UNION EUROPÉENNE
        </h6>
        <p>
            Cet avis de confidentialité s’applique à toutes les informations
            personnelles que l’Université de Californie du Sud (USC) et les
            chercheurs identifiés dans le consentement éclairé collectent ou
            traitent à votre sujet dans le cadre de votre participation à ce
            projet de recherche. Les informations personnelles sont des
            informations qui vous concernent et permettent de vous identifier (y
            compris par la combinaison d’informations). Certaines de ces
            informations personnelles peuvent inclure des informations classées
            comme
            <span style={{ fontWeight: 'bold' }}>« sensibles » </span> en vertu
            des lois locales sur la confidentialité (par exemple, des
            informations sur votre santé physique et mentale).
        </p>
        <p>
            Les informations collectées à votre sujet pour ce projet de
            recherche incluent des informations personnelles, par exemple
            démographiques, et peuvent inclure des données sensibles, telles que
            :
        </p>
        <ul>
            <li>votre origine ethnique </li>
            <li>vos opinions politiques</li>
            <li>vos croyances religieuses ou philosophiques </li>
            <li>votre affiliation syndicale </li>
            <li>vos informations génétiques ou biométriques </li>
            <li>des informations relatives à votre santé </li>
            <li>
                des informations relatives à votre vie sexuelle ou votre
                orientation sexuelle
            </li>
            <li>votre casier judiciaire</li>
        </ul>
        <p>
            La collecte et le traitement de vos informations personnelles
            reposent sur l’une ou plusieurs des bases légales suivantes :
        </p>
        <ul>
            <li>
                vous avez consenti à la collecte et au traitement de vos
                informations personnelles ; et/ou
            </li>
            <li>
                USC collecte et traite vos informations personnelles nécessaires
                à l’exécution d’une tâche effectuée dans l’intérêt public ;
            </li>
            <li>la loi l’exige.</li>
        </ul>
        <p>
            Vos données seront utilisées et/ou stockées aussi longtemps que
            nécessaire pour l’étude de recherche et conformément à la durée de
            l’autorisation de l’USC HIPAA à utiliser les informations
            personnelles à des fins de recherche.
        </p>
        <p style={{ textDecoration: 'underline' }}>Vos droits</p>
        <ul>
            <li>
                Vous avez le droit de consulter les informations recueillies à
                votre sujet dans l’étude. Afin de garantir l’intégrité de
                l’étude, vous ne pourrez pas examiner certaines des données
                avant la fin de l’étude. Par exemple, si vous participez à une
                étude en aveugle, ni les chercheurs ni vous ne pourrez connaître
                la section de l’étude à laquelle vous avez participé avant la
                fin de l’étude.
            </li>
            <li>
                Vous avez le droit de demander des corrections concernant vos
                informations personnelles si celles-ci sont inexactes.
            </li>
            <li>
                Vous avez le droit de limiter la collecte et l’utilisation de
                vos informations personnelles dans certaines circonstances (par
                exemple, si vous pensez que les informations sont inexactes).
            </li>
            <li>
                Vous avez le droit de demander la suppression de vos
                informations personnelles si vous ne participez plus à l’étude.
                Il existe cependant des limites à votre capacité à demander la
                suppression de vos informations personnelles, notamment si la
                suppression affecterait fortement l’intégrité ou l’efficacité de
                l’étude, ou si vos informations personnelles sont nécessaires à
                des fins de conformité aux exigences légales.
            </li>
            <li>
                Vous avez le droit de déposer une réclamation auprès d’une
                autorité de protection des données
                <a href="http://ec.europa.eu/justice/data-protection/article-29/structure/data-protection-authorities/index_en.htm">
                    (http://ec.europa.eu/justice/data-protection/article-29/structure/data-protection-authorities/index_en.htm).
                </a>
            </li>
        </ul>
        <p style={{ textDecoration: 'underline' }}>Retrait de l’étude</p>
        <p>
            Si vous vous retirez de l’étude, vous ne pourrez plus y participer.
            Aucune nouvelle information ni aucun échantillon ne sera collecté à
            votre sujet ou auprès de vous par l’équipe d’étude. Votre retrait
            n’a aucune incidence sur la légalité du traitement des données qui a
            eu lieu avant votre retrait.
        </p>
        <p>
            Après votre retrait, vos données et informations personnelles
            peuvent toujours être conservées pour maintenir l’intégrité de
            l’étude, pour satisfaire à toutes les exigences légales ou
            réglementaires, y compris aux exigences de déclaration et de
            conservation, et/ou à toute autre fin autorisée par les lois
            applicables en matière de protection des données et de
            confidentialité. Vos informations personnelles peuvent également
            être anonymisées afin que les informations ne vous identifient pas
            personnellement, et ces informations anonymisées peuvent être
            utilisées pour des recherches plus approfondies.
        </p>
        <p style={{ textDecoration: 'underline' }}>Sécurité</p>
        <p>
            Nous mettons en œuvre des mesures techniques et organisationnelles
            visant à assurer un niveau de sécurité approprié aux risques
            concernant les informations personnelles que nous traitons. Ces
            mesures visent à assurer en permanence l’intégrité et la
            confidentialité des informations personnelles. Nous évaluons
            régulièrement ces mesures pour garantir la sécurité du traitement.
            Pour plus d’informations sur les mesures de protection appropriées
            mises en place, veuillez nous contacter à l’adresse e-mail
            ci-dessous.
        </p>
        <p>
            Nous conserverons vos informations personnelles conformément à notre
            politique de gestion des informations, disponible à l’adresse
            <a href="https://policy.usc.edu/record-management/">
                https://policy.usc.edu/record-management/
            </a>
            , qui définit les périodes de conservation des données, tel que
            requis ou autorisé par la législation applicable.
        </p>
        <p style={{ textDecoration: 'underline' }}>
            Transfert international de données
        </p>
        <p>
            Vos données seront utilisées et partagées avec les chercheurs et les
            promoteurs de cette étude ainsi qu’avec les régulateurs
            gouvernementaux, conformément aux spécifications détaillées dans
            l’autorisation de la HIPAA à utiliser les informations personnelles
            à des fins de recherche. Vos informations personnelles peuvent être
            partagées avec des personnes en dehors de votre pays, y compris aux
            États-Unis, et seront traitées conformément aux lois applicables en
            matière de protection des données. La confidentialité et la
            protection des données dans ces pays peuvent ne pas offrir le même
            niveau de protection que celles de votre propre pays.
        </p>
        <p style={{ textDecoration: 'underline' }}>Contact</p>
        <p>
            Si vous avez des questions ou des préoccupations concernant
            l’utilisation de vos informations personnelles, veuillez contacter
            Morteza Dehghani (mdehghan@usc.edu).
        </p>
        <p style={{ textDecoration: 'underline' }}>Modifications de l’avis</p>
        <p>
            Vous pouvez nous demander une copie de cet avis de confidentialité
            en utilisant les coordonnées indiquées ci-dessus. Nous pouvons
            occasionnellement être amenés à modifier ou mettre à jour cet avis
            de confidentialité. La dernière mise à jour de l’avis de
            confidentialité sera indiquée par une date de révision. Les
            modifications et les ajouts à cet avis de confidentialité entrent en
            vigueur à compter de la date à laquelle ils sont publiés. Si des
            modifications apportées à cette politique doivent avoir un impact
            fondamental sur la nature du traitement ou vous affecter de manière
            significative, nous vous donnerons un préavis suffisant afin de vous
            laisser la possibilité d’exercer vos droits (par exemple, de vous
            opposer au traitement).
        </p>
    </React.Fragment>
);

const UserAgreement = ({ startSurvey }) => {
    const [agree, setAgree] = useState(false);
    const [date, setDate] = useState('');
    const [signMsg, setSignMsg] = useState(null);
    const checkBoxRef = useRef(null);
    const dateRef = useRef(null);
    const html =
        language === 'fr'
            ? { html1: html1_fr, html2: html2_fr }
            : { html1: html1_en, html2: html2_en };

    const intl = useIntl();
    const messages = defineMessages({
        needToAgree: {
            id: 'Agreement.needToAgree',
            defaultMessage: 'You need to agree to the consent and sign the date'
        }
    });

    useEffect(() => {
        setSignMsg(null);
    }, [agree, date]);

    const toCheckBox = () => {
        checkBoxRef.current.scrollIntoView({
            behavior: 'smooth'
        });
    };

    const toDate = () => {
        dateRef.current.scrollIntoView({
            behavior: 'smooth'
        });
    };

    return (
        <Container
            fluid
            className="mt-3 agreement"
            style={{
                textAlign: 'center',
                width: '95%',
                border: '1px solid black'
            }}
        >
            <Row
                className="py-2"
                style={{
                    background: 'rgb(153, 0, 0)',
                    fontSize: '1.5rem',
                    color: 'white'
                }}
            >
                <Col className="text-center text-md-left" xs={12} md={6}>
                    <FormattedMessage
                        id="USC.fullname"
                        defaultMessage="University of Southern California"
                    />
                </Col>
                <Col className="text-center text-md-right" xs={12} md={6}>
                    <FormattedMessage
                        id="USC.department"
                        defaultMessage="Department of Psychology"
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ padding: '1vh' }}>
                        <h3 className="agreement">
                            <FormattedMessage
                                id="consent.instruction"
                                defaultMessage="Please agree to the user agreement before proceeding."
                            />
                        </h3>

                        <h5 className="agreement">
                            <FormattedMessage
                                id="consent.name"
                                defaultMessage="User Agreement"
                            />
                        </h5>

                        <Row
                            className="text-left frame"
                            style={{
                                minHeight: '50vh',
                                maxHeight: '55vh',
                                overflow: 'scroll',
                                border: '1px solid gray'
                            }}
                        >
                            <Col>
                                <Container fluid>
                                    <Row>
                                        <Col>{html.html1}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={1} ref={checkBoxRef}>
                                            <Form.Check
                                                type="checkbox"
                                                value={agree}
                                                onChange={(e) =>
                                                    setAgree(e.target.checked)
                                                }
                                            />
                                        </Col>
                                        <Col>
                                            <p style={{ fontWeight: 'bold' }}>
                                                <FormattedMessage
                                                    id="consent.read"
                                                    defaultMessage="I have read (or someone has read to me) the information
                        provided above. I have been given a chance to ask
                        questions. All my questions have been answered. By
                        clicking this box, I am agreeing to take part in this
                        study."
                                                />
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>{html.html2}</Col>
                                    </Row>
                                    <Row>
                                        <Col xs={2}>Date: </Col>
                                        <Col ref={dateRef}>
                                            <Form.Group controlId="dob">
                                                <Form.Control
                                                    type="date"
                                                    name="dob"
                                                    placeholder="Date of Birth"
                                                    value={date}
                                                    onChange={(e) =>
                                                        setDate(e.target.value)
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>
                        <br />
                        {signMsg && (
                            <Row>
                                <Col>
                                    <Alert variant="danger">{signMsg}</Alert>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col>
                                <Button
                                    style={{
                                        backgroundColor: 'rgb(153, 0, 0)'
                                    }}
                                    onClick={() => {
                                        toDate();
                                        if (!agree || !date) {
                                            if (!agree) {
                                                toCheckBox();
                                            } else if (!date) {
                                                toDate();
                                            }
                                            setSignMsg(
                                                intl.formatMessage(
                                                    messages.needToAgree
                                                )
                                            );
                                            return;
                                        }
                                        startSurvey();
                                    }}
                                >
                                    <FormattedMessage
                                        id="consent.start"
                                        defaultMessage="Start Survey"
                                    />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default UserAgreement;
